import { Skeleton } from "antd";

import "./TextSkeleton.style.less";

const TextSkeleton = (props) => {
  return (
    <Skeleton
      classNames={{
        root: "text-skeleton",
        title: "text-skeleton--title",
      }}
      paragraph={false}
      active={true}
      round={false}
      {...props}
    />
  );
};

export default TextSkeleton;
